exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Business-Article-component{padding-bottom:60px}.Business-Article-component .header-title{overflow-y:hidden;max-height:44px;white-space:nowrap;text-overflow:ellipsis}.Business-Article-component .invite{width:80%;margin-left:10%;margin-top:50px}.Business-Article-component .invite .content{border-top:1px solid #ccc;width:100%}.Business-Article-component .invite .content p{border:1px solid #ccc;min-height:40px;background:#fff;padding:5px 10px;font-size:12px;word-break:break-all}.Business-Article-component .invite .content input{width:100%;height:40px;font-size:12px;padding-left:5px;padding-right:5px}.Business-Article-component .invite .content input[type=file]{border:1px solid #ccc;line-height:32px;margin-top:0}.Business-Article-component .invite .content textarea{font-size:12px;border:1px solid #ccc;height:200px}.Business-Article-component .invite .content button{padding:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/BusinessArticle.scss
// module id = 626
// module chunks = 0